import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { User, UserService } from './core/services/user/user.service';
import { FooterComponent } from './components/common/footer/footer.component';
import { NavbarComponent } from './components/common/navbar/navbar.component';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'angular-base';
  user: User | null = null;

  isUnimarc = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private analyticsService: AnalyticsService
  ) {
    this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      this.isUnimarc = event.url.includes('appunimarc');
    }
  });
  }

  ngOnInit(): void {
    this.user = this.userService.getUser();

    // Track initial page view
    this.analyticsService.trackPageView();

    // Track page views on navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.analyticsService.trackPageView(
          document.title,
          event.urlAfterRedirects
        );
      });
  }
}
